// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import DatePicker from 'antd/lib/date-picker';
import 'antd/lib/date-picker/style/css';
import moment, { isMoment } from 'moment';

// EXPORTED COMPONENT
// ===================================
export class DateInput extends React.Component {
  render() {
    let massagedValue = this.props.value;

    // if value does not exist, create a new moment object
    if (!this.props.value) {
      massagedValue = moment();
    }

    // if this.props.value exists and is a moment object already, we can use this.props.value
    if (this.props.value && isMoment(this.props.value) && this.props.value._isUTC) {
      massagedValue = moment(this.props.value);
    }

    if (this.props.value && !isMoment(this.props.value)) {
      massagedValue = moment(this.props.value);
    }

    return <DatePicker {...this.props} value={massagedValue} />;
  }
}

DateInput.propTypes = {
  size: PropTypes.string,
  style: PropTypes.object,
};

// Specifies the default values for props:
DateInput.defaultProps = {
  size: 'large',
  style: {},
};

export default DateInput;



// WEBPACK FOOTER //
// ./src/components/inputs/DateInput/index.js